export default __webpack_public_path__ + "static/media/aggregate.c5c174b1.svg";